<template>
  <div class="flex flex-col items-center">
    <label
      v-for="option in formattedOptions"
      :class="[
        option.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        labelClasses
      ]"
      :key="`${name}-checkbox-${option[key]}`"
      class="flex items-center w-full"
    >
      <t-checkbox
        :disabled="option.disabled"
        :id="`checkbox-${option[key]}`"
        :name="name"
        class="flex-grow-0"
        v-model="selected[option[key]]"
      />
      <section class="flex flex-grow items-center justify-between ml-2">
        <template v-if="$slots.label || $scopedSlots.label">
          <slot name="label" v-bind="option" />
        </template>
        <span v-else>
          {{ option[label] }}
        </span>
      </section>
    </label>
  </div>
</template>

<script>
import WCheckboxGroup from './WCheckboxGroup';

export default WCheckboxGroup;
</script>

<style lang="scss" scoped>
@import 'WCheckboxGroup';
</style>
